<template>
  <div style="height: 500px;">

    <img src="./Pulsar.jpg" height="22" class="mt-2">
    <h5>Пульсар Т1</h5>
    <small>Счетчик электроэнергии</small>
    
    <div class="mb-2 " v-if="shares">
      <span v-if="shares.online" class="badge m-0 bg-success">ONLINE</span>
      <span v-if="!shares.online" class="badge m-0 bg-danger">OFFLINE</span>
      <span v-if="shares.progress" class="badge m-1  bg-success">WORK</span>
      <span v-if="!shares.progress" class="badge m-1   bg-secondary">WORK</span>
    </div>
    <table v-if="shares && shares.channel" class="table table-sm table-striped align-middle text-center mt-3" style="">
      <thead>
        <th>Тариф</th>
        <th>КВт.Ч</th>
      </thead>
      <tbody>
      <tr v-for="(channel,index) of shares.channel" :key="id + 'TR' + index"><td>{{index + 1}}</td><td>{{channel}}</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'Pulsar1T',
  props: ['info','shares','id']
}
</script>
<style scoped>
</style>
